<template>
  <section>
    <b-row >
      <b-col class="box-effect linear"
        >
            <b-card 
              >   
                <template v-slot:header >
                  <div class="header-card">
                    Pendientes de aportes
                  </div> 
                </template> 
            
                <b-row style="margin-bottom:5px ;background: rgba(0, 80, 166, 0.03); 
                ;padding:15px;border: 1px ridge;" align-v="center">
                  <b-col
                    :md="4"
                    :lg="4">
                    <b-form-group
                      label="Mes Aporte"
                    >
                      <c-multiselect
                        style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                        v-model="mes_periodo"                   
                        :options="lists.list_mes"
                        label="name"
                        track-by="name"
                        :allow-empty="false"
                        :clear-on-select="false"
                        :preselect-first="false"
                        :searchable="false"
                        placeholder="Seleccionar"
                        >
                      </c-multiselect>
                    </b-form-group>
                  </b-col>
                  <b-col
                    :md="4"
                    :lg="4">
                    <b-form-group
                      label="Año Aporte"
                    >
                      <c-multiselect
                        style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                        v-model="ano_periodo"                   
                        :options="lists.list_ano"
                        label="name"
                        track-by="name"
                        :allow-empty="false"
                        :clear-on-select="false"
                        :preselect-first="false"
                        :searchable="false"
                        placeholder="Seleccionar"
                        >
                      </c-multiselect>
                    </b-form-group>
                  </b-col>
                  <b-col 
                    :md="4"
                    :lg="4">
                    <b-button @click="openPdf()" size="sm" :disabled="datos_razons.length===0" style="float:right">Imprimir</b-button>
                  </b-col>
                  <b-col 
                    :md="12"
                    :lg="12">
                    <b-form-group>
                      <template v-slot:label>
                        <b>Razón Social:</b><br>
                        <b-form-checkbox
                          v-model="allSelected"
                          :indeterminate="indeterminate"
                          aria-describedby="flavours"
                          aria-controls="flavours"
                          @change="toggleAll"
                        >
                          {{ allSelected ? 'Deseleccionar Todos' : 'Seleccionar Todos' }}
                        </b-form-checkbox>
                      </template>
                      <b-form-checkbox-group id="checkbox-group-2" v-model="datos_razons" name="flavour-2">
                        <b-form-checkbox v-if="option.id_list_estado.toString()==='1'" v-for="(option, index) in lists.datos_razon" :key="'checks'+index" :value="option.id">{{option.name}}</b-form-checkbox>
                      </b-form-checkbox-group>
                    </b-form-group>
                  </b-col>
                  <b-col>
                  </b-col>
                </b-row> 
                <h5 style="margin: 50px 0 20px">Notas pendientes
                  <b-button size="sm" @click="nuevoModal()" variant="outline-primary" style="float:right">Nueva nota</b-button>
                </h5>
                <sw-tableget
                    :tableOptions="tableGBoptions"
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    name="tableGet2"
                    route="get_notaspendientes"
                    :dataRoute="{others: [ ['id_list_mes', mes_periodo.id], ['id_list_ano', ano_periodo.id]]}"
                    :filterShow="false"
                    @save="saveForm"
                    @filtrar="getFiltrar"
                    >                          
                    <template v-slot:modal>
                      <sw-modaleditarpendientes
                        :list_mes="mes_periodo"
                        :list_ano="ano_periodo"
                        v-if="openModal.modal.modal==='Editar'"
                        @save="saveForm"                     
                        >
                      </sw-modaleditarpendientes>                         
                      <sw-modaldeletependientes 
                        v-if="openModal.modal.modal==='Eliminar'"
                        @save="saveForm"                     
                        >
                      </sw-modaldeletependientes> 
                    </template>                           
                  </sw-tableget>  
            </b-card>           
      </b-col>      
    </b-row> 
    <b-modal 
      v-if="openModal.modal.modal==='Nuevo'"
      v-model="openModal.modal.value"
      :title="openModal.modal.title" 
      :header-bg-variant="'primary'"
      header-text-variant="light"
      :hide-footer="true"  
      :no-close-on-backdrop="true" 
      size="lg"  
      >        
        <sw-modaleditarpendientes 
          :list_mes="mes_periodo"
          :list_ano="ano_periodo"
          @save="saveForm"                     
          >
        </sw-modaleditarpendientes>    
    </b-modal>  
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex"
import indexMix    from './indexMix.js'
import storeMix    from './storeMix.js'
import tableMix    from './tableMix.js'
import saveMix     from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import Multiselect from 'vue-multiselect'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwModaleditarpendientes from '@/components/modals/editarPendientes.vue'
import SwModaldeletependientes from '@/components/modals/deletePendientes.vue'

export default {
  name: "afiliacion_informes",
  components: { 
    'c-multiselect': Multiselect,
    SwModaleditarpendientes,
    SwModaldeletependientes,
    SwTableget,
    SwSaveform
  },
  mixins: [indexMix, storeMix, tableMix, saveMix, saveMixins,],
};
</script>
